/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowDefinitionFilter {
    getFixupPrototypeFunction() { return WorkFlowDefinitionFilter.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowDefinitionFilter>): WorkFlowDefinitionFilter {
        let obj = Object.assign(new WorkFlowDefinitionFilter(), model);
        WorkFlowDefinitionFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowDefinitionFilter>): WorkFlowDefinitionFilter {
        if (!model) return null;
        return WorkFlowDefinitionFilter.newInstance(<WorkFlowDefinitionFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowDefinitionFilter) {
        if (!obj) return;

        models.WorkFlowDefinitionFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowDefinitionFilter): boolean {
        Object.setPrototypeOf(obj, WorkFlowDefinitionFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Regular expression to match against the name
     */
    name: string;

    /**
     * Module for which the workflow which has to be generated.
     */
    module: models.WorkFlowModules;

    /**
     * SubCategory for which the workflow which has to be generated.
     */
    category: models.WorkFlowCategory;

    /**
     * Only include accounts from these Tenants.
     */
    tenant_ids: Array<string>;

    /**
     * User id for which the workflows needs to be listed.
     */
    owner: string;

    /**
     * Search term to be matched against the workflow name and description.
     */
    search: string;

}
